import { Link } from "react-router-dom";
import { ShieldAlert, Home } from "lucide-react";
import { ERRORS } from "@/constants/testIds";
import { useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/constants/roles";

export default function UnauthorizedPage() {
  const { user } = useAuth();
  const home = user ? (ROLE_HOME[user.role_code] || "/app/learner") : "/";
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4" data-testid={ERRORS.unauthorized}>
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <h1 className="mt-6 text-2xl font-black text-slate-900" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>Access denied</h1>
        <p className="mt-2 text-sm text-slate-600">
          You don't have permission to view this page. If this seems wrong, contact your Steward administrator.
        </p>
        <Link
          to={home}
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#101876] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0c135c]"
          data-testid={ERRORS.homeLink}
        >
          <Home className="h-4 w-4" /> Go to dashboard
        </Link>
      </div>
    </div>
  );
}
